import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  Chip,
  Grid,
  CircularProgress,
} from "@mui/material";

// Individual role card
const RoleCard = ({
  progress,
  total,
  category,
  role,
  currentRate,
  optimalRate,
  status,
  actionLabel,
  onActionClick,
}) => {
  const progressValue = (progress / total) * 100;

  return (
    <Card variant="outlined" sx={{ overflow: "hidden" }}>
      <CardContent sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        {/* Left circular progress */}
        <Box sx={{ position: "relative", display: "inline-flex" }}>
          <CircularProgress
            variant="determinate"
            value={progressValue}
            size={56}
            thickness={5}
            sx={{ color: "purple" }}
          />
          <Box
            sx={{
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              position: "absolute",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "12px",
              fontWeight: "600",
            }}
          >
            {progress}/{total}
          </Box>
        </Box>

        {/* Middle content */}
        <Box sx={{ flex: 1 }}>
          <Typography variant="subtitle2" fontWeight={600}>
            {category}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Deployment Roles: {role}
          </Typography>
          <Typography variant="caption" color="text.secondary" display="block">
            Current rate based on project history: ${currentRate}
          </Typography>
          <Typography variant="caption" color="text.secondary" display="block">
            Optimal rate: ${optimalRate}
          </Typography>
        </Box>

        {/* Right status/action */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {actionLabel ? (
            <Button
              variant="outlined"
              size="small"
              onClick={onActionClick}
              sx={{
                borderRadius: "20px",
                textTransform: "none",
              }}
            >
              {actionLabel}
            </Button>
          ) : (
            <Chip
              label={status}
              size="small"
              sx={{
                borderRadius: "20px",
                bgcolor:
                  status === "Rate Accepted, Hiring in Progress"
                    ? "#E8F5E9"
                    : status === "Pending Rate Acceptance"
                    ? "#FCE4EC"
                    : "#F5F5F5",
                color:
                  status === "Rate Accepted, Hiring in Progress"
                    ? "#2E7D32"
                    : status === "Pending Rate Acceptance"
                    ? "#AD1457"
                    : "#616161",
              }}
            />
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

// Full widget wrapper
const DeploymentRoleProgress = () => {
  const roles = [
    {
      progress: 32,
      total: 32,
      category: "Category: Orals Lead / Coach",
      role: "Orals Lead / Coach",
      currentRate: 36,
      optimalRate: 36,
      status: "Rate Accepted, Hiring in Progress",
    },
    {
      progress: 32,
      total: 32,
      category: "Category: Proposal Writer",
      role: "Commercial / Business Volume Writer, IMP / IMS Volume Writer",
      currentRate: 36,
      optimalRate: 36,
      actionLabel: "Accept Current Rate",
    },
    {
      progress: 32,
      total: 32,
      category: "Category: Proposal Writer",
      role: "Commercial / Business Volume Writer, IMP / IMS Volume Writer",
      currentRate: 36,
      optimalRate: 36,
      status: "In Review",
    },
    {
      progress: 12,
      total: 24,
      category: "Category: Orals Lead / Coach",
      role: "Orals Lead / Coach",
      currentRate: 36,
      optimalRate: 36,
      status: "Incomplete Project History",
      actionLabel: "Add Projects",
    },
  ];

  return (
    <Box sx={{ p: 2, m: "auto", width: "100%" }}>
      <Typography variant="h6" fontWeight={600} mb={2}>
        Deployment Role Progress Widget
      </Typography>
      {roles.map((role, index) => (
        <RoleCard key={index} {...role} />
      ))}
    </Box>
  );
};

export default DeploymentRoleProgress;
